export default {
  methods: {
    /**
     * Used to format a date string to exact format expected by backend, which is d/m/Y.
     * This is usually used to transform the value of a rmp/datepicker into the backend payload.
     * @param date
     * @returns {string|null}
     */
    transformDateObjectIntoDateAsString(date) {
      if (typeof date === 'undefined' || date === null) {
        return null;
      }

      return new Date(date).toJSON()
        .split('T')[0]
        .split('-')
        .reverse()
        .join('/');
    },

    /**
     * Used to transform a date as string d/m/Y into a date object.
     * This is usually used to set the value of a rmp/datepicker
     * @param date
     * @returns {Date}
     */
    transformDateFromStringToDateObject(date) {
      const dateAsArray = date.split('/');
      return new Date(`${dateAsArray[2]}-${dateAsArray[1]}-${dateAsArray[0]}`);
    },
  },

};
